export const FETCH_DATA = 'FETCH_DATA';
export const FETCH_ALL_DEVICES = 'FETCH_ALL_DEVICES';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const FETCH_ADDRESS = 'FETCH_ADDRESS';
export const FETCH_ALL_CLIENTS = 'FETCH_ALL_CLIENTS';
export const SET_REQUEST_COUNTER = 'SET_REQUEST_COUNTER';
